import * as React from "react";
import './Pick.css';
import './Situation.css';
import '../../components/Typograph.css';
import Kozijnen from "./situation/Kozijnen";
import Luiken from "./situation/Luiken";
import Breedte from "./situation/Breedte";
import DraaitypeWindow from "./situation/DraaitypeWindow";
import Hoogte from "./situation/Hoogte";
import {LuikType, MontageType} from "../../Model";
import MontageWindow from "./situation/MontageWindow";
import HengtypeWindow from "./situation/HengtypeWindow";
import MaatA from "./situation/MaatA";
import MaatD from "./situation/MaatD";
import MaatK from "./situation/MaatK";
import MaatM from "./situation/MaatM";
import MaatT from "./situation/MaatT";
import MaatS from "./situation/MaatS";
import PropTypes from "prop-types";
import {useEffect} from "react";
import PhoneAppFooter from "../../components/PhoneAppFooter";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import SituatieInfo from "./situation/SituatieInfo";
import SituatieEind from "./situation/SituatieEind";
import {hasValue, validateAmountWithRotationType, validateHangPoints, validateKlampen} from "../../util/Validator";
import MaatY from "./situation/MaatY";

SituationPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
    disablePhoneMode: PropTypes.func.isRequired,
}

export const KOZIJNEN = "kozijnen";
export const LUIKEN = "luiken";
export const BREEDTE = "breedte";
export const HOOGTE = "hoogte";
export const MONTAGE = "montage";
export const DRAAITYPE = "draaitype";
export const HENGTYPE = "hengtype";
export const MAATA = "maatA";
export const MAATY = "maatY";
export const MAATD = "maatD";
export const MAATK = "maatK";
export const MAATM = "maatM";
export const MAATT = "maatT";
export const MAATS = "maatS";

export const requiredTypesWhenKozijnMontage = [MAATA, MAATK];
export const requiredTypesWhenOpgeklampt = [MAATY];

export const columns = [
    KOZIJNEN,
    LUIKEN,
    BREEDTE,
    HOOGTE,
    MONTAGE,
    DRAAITYPE,
    HENGTYPE,
    MAATA,
    MAATY,
    MAATD,
    MAATK,
    MAATM,
    MAATT,
    MAATS
];

export const titles = [
    "Kozijnen",
    "Luiken",
    "Breedte",
    "Hoogte",
    "Montage",
    "Draaitype",
    "Hengtype",
    "Maat A",
    "Maat Y",
    "Maat D",
    "Maat K",
    "Maat M",
    "Maat T",
    "Maat S"
];

export default function SituationPick(props) {
    const currentValue = props.allValues.SituationPick;
    const klamptZichtbaar = props.allValues.TypePick === LuikType.VENSTERLUIK_VISIBLE_CLAMS;
    const klamptOnzichtbaar = props.allValues.TypePick === LuikType.VENSTERLUIK_INVISIBLE_CLAMS;
    let klampen = "none";
    if (klamptZichtbaar) {
        klampen = "visible"
    } else if (klamptOnzichtbaar) {
        klampen = "invisible"
    }

    const hasStijlbreedte = props.allValues.TypePick === LuikType.LOUVRELUIK || props.allValues.TypePick === LuikType.PANEELLUIK;
    const luiktype = props.allValues.TypePick;
    const isMuurMontage = (index) => getIf(currentValue.data, index, "montage") === MontageType.MUUR;

    useEffect(() => {
        if (currentValue == null) {
            props.handlePageChange({
                row: 1,
                currentRow: 0,
                currentColumn: -1,
                data: [{montage: MontageType.MUUR}]
            })
        }
    }, []);

    const nextRow = () => {
        const data = JSON.parse(JSON.stringify(currentValue.data));
        let amount = currentValue.row;
        if (currentValue.currentRow + 1 >= amount) {
            amount = Math.min(amount + 1, 7);
            while (data.length < amount) {
                data.push({montage: MontageType.MUUR});
            }
        }
        props.handlePageChange({
            row: amount,
            currentRow: currentValue.currentRow + 1,
            currentColumn: -1,
            data
        });
    }

    function validColumn(newColumn) {
        return ((columns[newColumn] === MAATA
                    || columns[newColumn] === MAATK)
                && isMuurMontage(currentValue.currentRow))
            || (columns[newColumn] === MAATS
                && (currentValue.currentRow !== 0 || !hasStijlbreedte));
    }

    const previous = () => {
        const data = JSON.parse(JSON.stringify(currentValue.data));

        let newColumn = currentValue.currentColumn - 1
        while (validColumn(newColumn)) {
            newColumn--;
        }


        if (newColumn < -1) {
            const newRow = currentValue.currentRow - 1;
            if (newRow < 0) {
                props.handlePreviousPage();
                return;
            }

            let newColumnAfterReset = columns.length - 1;
            while (validColumn(newColumnAfterReset)) {
                newColumnAfterReset--;
            }

            props.handlePageChange({
                row: currentValue.row,
                currentRow: newRow,
                currentColumn: newColumnAfterReset,
                data
            });
        } else {
            props.handlePageChange({
                row: currentValue.row,
                currentRow: currentValue.currentRow,
                currentColumn: newColumn,
                data
            });
        }
    }

    const next = () => {
        const data = JSON.parse(JSON.stringify(currentValue.data));

        let newColumn = currentValue.currentColumn + 1
        while (validColumn(newColumn)) {
            newColumn++;
        }

        if (newColumn > columns.length) {
            props.handlePageChange({
                row: currentValue.row,
                currentRow: currentValue.row - 1,
                currentColumn: columns.length,
                data
            });
            props.handleNextPage();
        } else {
            props.handlePageChange({
                row: currentValue.row,
                currentRow: currentValue.currentRow,
                currentColumn: newColumn,
                data
            });
        }
    }

    const removeRow = (index) => {
        if (index < 1) return;
        const data = JSON.parse(JSON.stringify(currentValue.data));
        data.splice(index, 1);
        props.handlePageChange({
            row: currentValue.row - 1,
            currentRow: currentValue.currentRow - 1,
            currentColumn: -1,
            data
        });
    }

    const changedInput = (row, property) => value => {
        if (value.currentTarget) {
            value = value.currentTarget.value;
        }
        const data = JSON.parse(JSON.stringify(currentValue.data));
        data[row][property] = value;
        props.handlePageChange({
            row: currentValue.row,
            currentRow: currentValue.currentRow,
            currentColumn: currentValue.currentColumn,
            data
        });
    }

    if (currentValue == null) {
        return <div></div>;
    }


    const columnValue = getIf(currentValue.data, currentValue.currentRow, columns[currentValue.currentColumn]);
    const kozijnValue = getIf(currentValue.data, currentValue.currentRow, KOZIJNEN);
    const luikenValue = getIf(currentValue.data, currentValue.currentRow, LUIKEN);
    const hoogteValue = getIf(currentValue.data, currentValue.currentRow, HOOGTE);

    const canContinue = () => {
        if (currentValue.currentColumn < 0 || currentValue.currentColumn > columns.length - 1) {
            return true;
        }

        // noinspection JSUnreachableSwitchBranches
        switch (columns[currentValue.currentColumn]) {
            case KOZIJNEN:
            case LUIKEN:
            case BREEDTE:
            case HOOGTE:
            case MAATY:
            case MAATD:
            case MAATM:
            case MAATT:
            case MAATS:
                return hasValue(columnValue);
            case DRAAITYPE:
                return validateAmountWithRotationType(-1, columnValue, kozijnValue, luikenValue, true).length <= 0
                    && hasValue(columnValue);
            case HENGTYPE:
                return validateKlampen(-1, columnValue, luiktype, true).length <= 0
                    && validateHangPoints(-1, columnValue, hoogteValue, true).length <= 0
                    && hasValue(columnValue);
            case MONTAGE:
                return true;
            case MAATA:
            case MAATK:
                return isMuurMontage(currentValue.currentRow) ? true : hasValue(columnValue);
            default:
                return false;
        }
    }

    const canIgnore = () => {
        return (columns[currentValue.currentColumn] === HENGTYPE
                || columns[currentValue.currentColumn] === DRAAITYPE)
            && hasValue(columnValue);
    }

    const getWindow = () => {
        const onChange = changedInput(currentValue.currentRow, columns[currentValue.currentColumn]);
        const onEnter = () => {
            if (canContinue()) {
                next();
            }
            return true;
        };

        if (currentValue.currentColumn < 0) {
            return <SituatieInfo currentRow={currentValue.currentRow}
                                 onRemoveRow={() => removeRow(currentValue.currentRow)}/>;
        }
        if (currentValue.currentColumn > columns.length - 1) {
            return <SituatieEind canAddRow={currentValue.row < 7}
                                 totalRows={currentValue.row}
                                 currentRow={currentValue.currentRow}
                                 nextRow={nextRow}
                                 data={currentValue.data}
                                 isMuurMontage={isMuurMontage(currentValue.currentRow)}
                                 isOpgeklampt={klamptZichtbaar || klamptOnzichtbaar}/>;
        }

        // noinspection JSUnreachableSwitchBranches
        switch (columns[currentValue.currentColumn]) {
            case KOZIJNEN:
                return <Kozijnen onChange={onChange} value={columnValue} onEnter={onEnter}/>;
            case LUIKEN:
                return <Luiken onChange={onChange} value={columnValue} onEnter={onEnter}/>;
            case BREEDTE:
                return <Breedte onChange={onChange} value={columnValue} onEnter={onEnter}/>;
            case HOOGTE:
                return <Hoogte onChange={onChange} value={columnValue} onEnter={onEnter}/>;
            case MONTAGE:
                return <MontageWindow currentValue={columnValue} onChange={onChange}/>;
            case DRAAITYPE:
                return <DraaitypeWindow currentValue={columnValue}
                                        onChange={onChange}
                                        kozijnValue={kozijnValue}
                                        luikenValue={luikenValue}/>;
            case HENGTYPE:
                return <HengtypeWindow currentValue={columnValue}
                                       onChange={onChange}
                                       luiktype={luiktype}
                                       hoogte={hoogteValue}/>;
            case MAATA:
                return <MaatA onChange={onChange} value={columnValue} onEnter={onEnter}/>;
            case MAATY:
                return <MaatY onChange={onChange} value={columnValue} onEnter={onEnter}
                              isMuurMontage={isMuurMontage(currentValue.currentRow)} klampen={klampen}/>;
            case MAATD:
                return <MaatD onChange={onChange} value={columnValue} onEnter={onEnter}
                              klampen={klampen}
                              isMuurMontage={isMuurMontage(currentValue.currentRow)}/>;
            case MAATK:
                return <MaatK onChange={onChange} value={columnValue} onEnter={onEnter}/>;
            case MAATM:
                return <MaatM onChange={onChange} value={columnValue} onEnter={onEnter}
                              isMuurMontage={isMuurMontage(currentValue.currentRow)}/>;
            case MAATT:
                return <MaatT onChange={onChange} value={columnValue} onEnter={onEnter}
                              isMuurMontage={isMuurMontage(currentValue.currentRow)}/>;
            case MAATS:
                return <MaatS onChange={onChange} value={columnValue} onEnter={onEnter}/>;
            default:
                return null;
        }
    }

    let pageName = titles[currentValue.currentColumn];
    if (currentValue.currentColumn < 0) {
        pageName = "Informatie";
    } else if (currentValue.currentColumn > columns.length - 1) {
        pageName = "Afgerond"
    }
    let title = "Situatie " + (currentValue.currentRow + 1) + (currentValue.row > 1 ? (" / " + (currentValue.row)) : "") + " - " + pageName

    return (
        <div className="page">
            <PhoneAppHeader title={title}
                            quitPhoneApp={props.disablePhoneMode}
                            onPrevious={previous}/>

            {getWindow()}

            <PhoneAppFooter onNext={next}
                            enableNext={canContinue()}
                            enableIgnore={canIgnore()}/>
        </div>
    );
}

function getIf(array, index, key) {
    if (array[index] == null || array[index][key] == null) {
        return "";
    }
    return array[index][key];
}